<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="关联订单号" prop="orderNo">
        <el-input v-model="searchData.orderNo" placeholder="请输入" allowClear></el-input>
      </el-form-item>
      <el-form-item label="接收手机号" prop="billNo">
        <el-input v-model="searchData.billNo" placeholder="请输入" allowClear></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="referralType">
        <el-select v-model="searchData.dealStatus" placeholder="请选择" clearable>
          <el-option v-for="item in dealStatusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="btn-group">

      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="用户编号" prop="billNo" min-width="220"></el-table-column>
      <el-table-column label="关联订单号" prop="requestType" min-width="100">
      </el-table-column>
      <el-table-column label="手机号" prop="orderNum" min-width="160"></el-table-column>
      <el-table-column label="短信内容" prop="payNo" min-width="100"></el-table-column>
      <el-table-column label="状态" prop="dealStatus" min-width="120">
        <template slot-scope="scope">
          <span>{{ dealStatusStrFun(scope.row.dealStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发送时间" prop="accountDate" min-width="140"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.rows"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import mixin from '@/views/dataBoard/mixin'
import { getManagementList } from '@/api/recoveryManagement'
import { dealStatusList, expenseTypeList, requestTypeMap, dealStatusMap, orderStateMap, expenseTypeMap } from './paymentEnums'
export default {
  // mixins: [mixin],
  data() {
    return {
      dealStatusList: dealStatusList,
      expenseType: expenseTypeList,
      options: [],
      // 查询数据
      searchData: {
        orderNo: undefined,
        dealStatus: undefined,
        billNo: undefined,
        payNo: undefined,
        province: undefined,
        city: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        completeStartTime: undefined,
        completeEndTime: undefined,
        expenseType: undefined,
        contactMobile: undefined,
        partnershipId: undefined,
        requestType: undefined
      },
      // 表格数据
      tableData: [],
      tableLoading: false,
      pagination: {
        page: 1,
        rows: 10
      },
      total: 0,
      selectList: [],
      exportFlag: false,
      createTime: [],
      completeTime: [],
      provinceList: [],
      cityList: [],
      requestOptions: [
        { value: 1, label: '冻结' },
        { value: 2, label: '提现' }
      ]
    }
  },
  mounted() {
    this.getList(), this.getManagementList(), this.provinceChangeFun()
  },
  methods: {
    // 获取分页数据
    getList() {
      const url = `/autoapp-default-server-recovery/api/userBill/pageCondition`
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      return this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode === 200) {
          this.total = res.data.total || 0
          const resData = res.data.records || []
          this.tableData = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 清空
    resetForm() {
      // 重置搜索条件
      Object.assign(this.searchData, {
        payNo: undefined,
        billNo: undefined,
        orderNo: undefined,
        dealStatus: undefined,
        province: undefined,
        city: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        completeStartTime: undefined,
        completeEndTime: undefined,
        expenseType: undefined,
        contactMobile: undefined,
        partnershipId: undefined,
        requestType: undefined
      })

      // 重置时间选择器
      this.createTime = []
      this.completeTime = []

      this.getList()
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 选择改变
    selectChangeFun(selection) {
      this.selectList = selection
    },
    //
    goPaymentDetail(row) {
      this.$router.push({
        name: '/paymentManagement/orderDetail',
        query: {
          billNo: row.billNo
        }
      })
    },
    //
    goOrderDetail(row) {
      this.$router.push({
        path: '/order/orderEdit',
        query: {
          id: row.orderNum,
          // params: this.paramsData(),
          type: 'billDetail'
        }
      })
    },
    // 导出
    exportBtnFun() {
      this.exportFlag = true
      setTimeout(() => {
        this.exportFlag = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/userBill/export/pageCondition'
      const title = '账单明细数据导出'
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      this.global.exportExcel(url, params, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },

    // 省改变
    provinceChangeFun() {
      this.searchData.city = undefined
      this.searchData.districtCode = undefined
      return this.HttpService.get('/autoapp-default-server-recovery/api/tbl-province/getTblProvince').then(res => {
        if (res.statusCode === 200) {
          this.provinceList = res.data
          this.cityChangeFun()
        }
      })
    },
    // 市改变
    cityChangeFun() {
      this.searchData.districtCode = undefined
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-city/getTblCity?sfen=${this.searchData.province}`).then(res => {
        if (res.statusCode === 200) {
          this.cityList = res.data
        }
      })
    },

    getManagementList() {
      const params = {
        partnershipType: 2,
        pageNum: 1,
        pageSize: 999
      }
      getManagementList(params).then(res => {
        if (res.statusCode === 200) {
          this.options = res.data
        }
      })
    },

    dealStatusStrFun(type) {
      return dealStatusMap[type] || ''
    },
    orderStateStrFun(type) {
      return orderStateMap[type] || ''
    },

    getAddress(row) {
      const addressFields = [row.provinceName, row.cityName, row.districtName, row.townName, row.address]
      return addressFields.filter(field => field && field !== '').join('-')
    },

    handleCreateTimeChange() {
      this.searchData.createStartTime = this.createTime[0]
      this.searchData.createEndTime = this.createTime[1]
    },

    handleCompleteTimeChange() {
      this.searchData.completeStartTime = this.completeTime[0]
      this.searchData.completeEndTime = this.completeTime[1]
    }
  }
}
</script>
<style scoped lang="scss">
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/paymentManagement/messageStatistical.vue